import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDitio = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "Ditio logo"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 3,
			width: 24,
			height: 3,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 10,
			width: 24,
			height: 3,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 17,
			width: 24,
			height: 3,
			rx: 1.5
		})
	] })]
});
export default SvgDitio;
